// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUJFquwSdu6C3vMdSToJXsGhf6yPXhnbU",
  authDomain: "eventable-e30d5.firebaseapp.com",
  databaseURL:
    "https://eventable-e30d5-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "eventable-e30d5",
  storageBucket: "eventable-e30d5.appspot.com",
  messagingSenderId: "299964092287",
  appId: "1:299964092287:web:49adfb72b1648b9679144a",
  measurementId: "G-MLC91MF8HQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
